const consonantCyr = [
  "Б",
  "б",
  "В",
  "в",
  "Г",
  "г",
  "Д",
  "д",
  "Ж",
  "ж",
  "З",
  "з",
  "Й",
  "й",
  "К",
  "к",
  "М",
  "м",
  "Н",
  "н",
  "П",
  "п",
  "Р",
  "р",
  "С",
  "с",
  "Т",
  "т",
  "Ў",
  "ў",
  "Ф",
  "ф",
  "Х",
  "х",
  "Ц",
  "ц",
  "Ч",
  "ч",
  "Ш",
  "ш",
];

const consonantLat = [
  "B",
  "b",
  "V",
  "v",
  "H",
  "h",
  "D",
  "d",
  "Ž",
  "ž",
  "Z",
  "z",
  "J",
  "j",
  "K",
  "k",
  "M",
  "m",
  "N",
  "n",
  "P",
  "p",
  "R",
  "r",
  "S",
  "s",
  "T",
  "t",
  "Ŭ",
  "ŭ",
  "F",
  "f",
  "Ch",
  "ch",
  "C",
  "c",
  "Č",
  "č",
  "Š",
  "š",
];

const jTable = [
  [
    ["Е", "е"],
    ["E", "e"],
  ],
  [
    ["Ё", "ё"],
    ["O", "o"],
  ],
  [
    ["Ю", "ю"],
    ["U", "u"],
  ],
  [
    ["Я", "я"],
    ["A", "a"],
  ],
];

const softConsonants = [
  ["Ц", "Ć"],
  ["Л", "L"],
  ["Н", "Ń"],
  ["С", "Ś"],
  ["З", "Ź"],
  ["ц", "ć"],
  ["л", "l"],
  ["н", "ń"],
  ["с", "ś"],
  ["з", "ź"],
];

const vowelsCyr = ["А", "а", "І", "і", "О", "о", "У", "у", "Ы", "ы", "Э", "э"];
const vowelsLat = ["A", "a", "I", "i", "O", "o", "U", "u", "Y", "y", "E", "e"];

export function latinize(text) {
  let result = text;

  const consonantStr = consonantCyr.join();
  for (const [[capital, small], [latCapital, latSmall]] of jTable) {
    result = result
      .replaceAll(new RegExp(`Л${capital}`, "g"), `L${latCapital}`)
      .replaceAll(new RegExp(`л${capital}`, "g"), `l${latCapital}`)
      .replaceAll(new RegExp(`Л${small}`, "g"), `L${latSmall}`)
      .replaceAll(new RegExp(`л${small}`, "g"), `l${latSmall}`)
      .replaceAll(
        new RegExp(`([${consonantStr}])${capital}`, "g"),
        `$1I${latCapital}`
      )
      .replaceAll(
        new RegExp(`([${consonantStr}])${small}`, "g"),
        `$1i${latSmall}`
      )
      .replaceAll(`'${capital}`, `J${latCapital}`)
      .replaceAll(`'${small}`, `j${latSmall}`)
      .replaceAll(capital, `J${latSmall}`)
      .replaceAll(small, `j${latSmall}`);
  }

  result = result
    .replaceAll("ЛІ", "LI")
    .replaceAll("Лі", "Li")
    .replaceAll("лІ", "lI")
    .replaceAll("лі", "li")
    .replaceAll("'і", "ji")
    .replaceAll("'І", "JI");

  for (const [cyr, lat] of softConsonants) {
    result = result.replaceAll(`${cyr}ь`, lat).replaceAll(`${cyr}Ь`, lat);
  }

  for (let i = 0; i < consonantCyr.length; i++) {
    result = result.replaceAll(consonantCyr[i], consonantLat[i]);
  }

  for (let i = 0; i < vowelsCyr.length; i++) {
    result = result.replaceAll(vowelsCyr[i], vowelsLat[i]);
  }

  result = result.replaceAll("Л", "Ł").replaceAll("л", "ł").replaceAll("ь", "");

  return result;
}
